/* ═══════════════════════════════════════════════════════════════════════════
   SOCLE — le moteur commun des maquettes « matelas à eau » v3.

   Principe tenu par les deux pages de référence, et qu'on reprend tel quel :
   🛑 LE JS N'ANIME JAMAIS UNE PROPRIÉTÉ. Il calcule un scalaire, le CSS fait
      l'image. Trois scalaires en tout :

        --calme  sur <html>  : 0 en haut de page, 1 en bas
        --prog   sur la jauge : la course, mesurée sur la SECTION
        --p      sur chaque <section data-scene> : -1 haut, 0 centre, +1 bas

   Et trois exigences de tenue :
     · un écouteur `scroll` PASSIF, une seule boucle rAF ;
     · on lit TOUS les rects avant d'en écrire un seul (sinon aller-retour de
       mise en page à chaque élément) ;
     · la boucle S'ARRÊTE 400 ms après le dernier mouvement — aucun travail
       quand la page est immobile.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var doc = document.documentElement;
  doc.className += ' js';

  var calme = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── `--k` : la parallaxe de moitié au téléphone ──────────────────────────
     ⚠️ Il DOIT vivre sur <html> : une déclaration sur la section battrait la
     valeur héritée et doublerait l'amplitude. */
  function majK() { doc.style.setProperty('--k', window.innerWidth < 760 ? '.5' : '1'); }
  majK();
  addEventListener('resize', majK, { passive: true });

  /* ── LES SCÈNES VISIBLES ─────────────────────────────────────────────────
     On ne calcule que ce qui approche : 2 ou 3 sections, jamais toute la page. */
  var scenes = [].slice.call(document.querySelectorAll('[data-scene]'));
  var visibles = [];
  if (scenes.length && 'IntersectionObserver' in window) {
    var ioProche = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        var i = visibles.indexOf(e.target);
        if (e.isIntersecting) {
          if (i < 0) visibles.push(e.target);
          e.target.classList.add('proche');       // pose will-change
        } else {
          if (i >= 0) visibles.splice(i, 1);
          e.target.classList.remove('proche');
        }
      });
    }, { rootMargin: '25% 0px 25% 0px' });
    scenes.forEach(function (s) { ioProche.observe(s); });
  }

  /* ── LA BOUCLE ───────────────────────────────────────────────────────────── */
  var enCours = false, dernierMouvement = 0;
  var jauge = document.querySelector('.jauge i');
  var chapNom = document.querySelector('[data-chapitre]');
  var chapitres = [];

  /* Le nom du chapitre est LU SUR LA PAGE, jamais écrit à la main : une liste
     de liens écrite à part est exactement ce qui donne à une page l'air d'une
     documentation. */
  [].forEach.call(document.querySelectorAll('h2'), function (t) {
    var sec = t.closest('section[id], section');
    if (!sec) return;
    var nom = (t.getAttribute('data-chap') || t.textContent || '').replace(/\s+/g, ' ').trim();
    if (nom) chapitres.push({ sec: sec, t: nom });
  });

  function boucle() {
    var vh = window.innerHeight, demi = vh / 2;

    /* ①  LECTURE groupée — aucun style écrit ici. */
    var n = visibles.length, rects = new Array(n), i;
    for (i = 0; i < n; i++) rects[i] = visibles[i].getBoundingClientRect();
    var haut = doc.scrollHeight - vh;
    var course = haut > 0 ? Math.min(1, Math.max(0, window.scrollY / haut)) : 0;
    var rc = [];
    for (i = 0; i < chapitres.length; i++) rc.push(chapitres[i].sec.getBoundingClientRect().top);

    /* ②  ÉCRITURE groupée. */
    for (i = 0; i < n; i++) {
      var r = rects[i];
      var p = (demi - (r.top + r.height / 2)) / (demi + r.height / 2);
      visibles[i].style.setProperty('--p', (p < -1 ? -1 : p > 1 ? 1 : p).toFixed(4));
    }

    /* 🛑 `--calme` : LA THÈSE DE CETTE VERSION. La page se comporte comme la
       chose qu'elle vend — on entre dans une eau agitée, elle s'apaise en
       descendant, et le geste d'achat se fait dans le silence. Toute amplitude
       du CSS est multipliée par `--agite`. */
    doc.style.setProperty('--calme', course.toFixed(4));
    doc.style.setProperty('--agite', (1 - course).toFixed(4));

    if (jauge) jauge.style.setProperty('--prog', course.toFixed(4));

    if (chapNom && chapitres.length) {
      var k = 0;
      for (i = 0; i < chapitres.length; i++) if (rc[i] <= vh * 0.34) k = i;
      if (chapNom.textContent !== chapitres[k].t) chapNom.textContent = chapitres[k].t;
    }

    if (Date.now() - dernierMouvement > 400) { enCours = false; return; }
    requestAnimationFrame(boucle);
  }

  function demande() {
    dernierMouvement = Date.now();
    if (enCours) return;
    enCours = true;
    requestAnimationFrame(boucle);
  }
  addEventListener('scroll', demande, { passive: true });
  addEventListener('resize', demande, { passive: true });
  demande();

  /* ── L'ENTRÉE — une seule fois, puis on se débranche ─────────────────────── */
  if (!calme && 'IntersectionObserver' in window) {
    var ioVu = new IntersectionObserver(function (ents, o) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vu');
        o.unobserve(e.target);                 // elle ne rejoue jamais
      });
    }, { threshold: 0.22 });
    [].forEach.call(document.querySelectorAll('.entre, .monte'), function (n) { ioVu.observe(n); });
  } else {
    [].forEach.call(document.querySelectorAll('.entre, .monte'), function (n) { n.classList.add('vu'); });
  }

  /* ── LES FILMS ───────────────────────────────────────────────────────────
     Jamais deux à la fois, jamais de `src` avant le besoin, pause hors écran,
     et un `.catch()` silencieux : un refus d'autoplay n'est pas une erreur. */
  var films = [].slice.call(document.querySelectorAll('video[data-src], video[data-auto]'));
  function stop(sauf) {
    films.forEach(function (v) { if (v !== sauf && !v.paused) v.pause(); });
  }
  function joue(v) {
    if (!v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
    stop(v);
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {});
  }
  if (films.length && 'IntersectionObserver' in window) {
    var ioFilm = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.55) joue(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: [0, 0.25, 0.55, 0.8, 1] });
    films.forEach(function (v) {
      ioFilm.observe(v);
      /* chaque film porte la seconde où le sujet entre dans le cadre : on ne
         montre jamais l'amorce. */
      var d = parseFloat(v.getAttribute('data-debut')) || 0;
      if (d) {
        var cale = function () { try { if (v.currentTime < d - 0.15) v.currentTime = d; } catch (e) {} };
        v.addEventListener('loadedmetadata', cale);
        v.addEventListener('play', cale);
        v.addEventListener('timeupdate', cale);
      }
    });
  }

  /* ── LE PLAN-SÉQUENCE ÉPINGLÉ ────────────────────────────────────────────
     `<div data-piste><div data-colle><video data-film …>`. La course de la
     piste commande `currentTime`.
     ⚠️ Trois mesures faites sur ce dépôt et qu'on ne refait pas :
       · UNE seule écriture de `currentTime` par rAF — 86 à 98 % des mises à
         jour sont abandonnées de toute façon ;
       · 1280×720 est un PLAFOND (216 ms de gel en 1080p contre 92) ;
       · on charge le film en BLOB : un blob est intégralement navigable, donc
         les `seek` sont instantanés. */
  [].forEach.call(document.querySelectorAll('[data-piste]'), function (piste) {
    var colle = piste.querySelector('[data-colle]');
    var v = piste.querySelector('video[data-film]');
    if (!v || !colle) return;
    var beats = [].slice.call(piste.querySelectorAll('[data-temps]'));
    var jaugeF = piste.querySelector('[data-jauge-film] i');
    var cible = 0, cur = 0, charge = false;
    var tel = window.innerWidth < 760;

    function tic() {
      var r = piste.getBoundingClientRect();
      var cse = r.height - window.innerHeight;
      var brut = cse <= 0 ? 0 : Math.min(1, Math.max(0, -r.top / cse));

      if (!charge && r.top < window.innerHeight * 4) {
        charge = true;
        var u = v.getAttribute('data-film');
        /* ⚠️ `fetch` REFUSE le schéma `file:` — en maquette locale le blob est
           impossible, et l'essayer quand même remplit la console d'erreurs
           rouges qui font croire à une panne. On ne tente le blob que là où il
           peut marcher ; ailleurs la source directe suffit, elle est locale. */
        /* 🛑 ET IL FAUT APPELER `load()`. Mesuré : avec `preload="none"`, poser
           un `src` ne déclenche RIEN — `readyState` reste à 0, `duration` reste
           NaN, et écrire `currentTime` n'a aucun effet. Le plan épinglé montrait
           son affiche et ne bougeait jamais, sur toute la course. Le défaut est
           muet : aucune erreur, aucune trace, juste une image fixe qu'on prend
           pour un choix de mise en scène. */
        var poser = function (s) { v.preload = 'auto'; v.src = s; v.load(); };
        if (location.protocol === 'file:') { poser(u); }
        else {
          fetch(u).then(function (x) { return x.ok ? x.blob() : Promise.reject(); })
            .then(function (b) { poser(URL.createObjectURL(b)); })
            .catch(function () { poser(u); });
        }
        /* une vidéo muette jamais jouée ne peint aucune image : sans ce saut
           de 1 ms on ne voit que le poster. */
        v.addEventListener('loadeddata', function () { try { v.currentTime = 0.001; } catch (e) {} },
          { once: true });
      }

      if (!v.seeking) {
        cur += (cible - cur) * (calme ? 1 : 0.18);   // le film GLISSE, il ne saute pas
        var d = v.duration || 0;
        if (d) {
          var t = Math.min(Math.max(cur, 0), 0.999) * d;
          var eps = tel ? 0.02 : 0.008;              // zone morte : une demi-image
          if (Math.abs(v.currentTime - t) > eps) { try { v.currentTime = t; } catch (e) {} }
        }
      }
      cible = brut;
      if (jaugeF) jaugeF.style.setProperty('--prog', brut.toFixed(4));
      beats.forEach(function (b) {
        var f = (b.getAttribute('data-temps') || '0,1').split(',');
        b.classList.toggle('on', brut >= parseFloat(f[0]) && brut < parseFloat(f[1]));
      });
      /* un plan épinglé ne partage pas l'écran : la barre d'action se retire */
      var plein = r.top <= 1 && r.bottom >= window.innerHeight - 1;
      doc.toggleAttribute('data-film-plein', plein);
      requestAnimationFrame(tic);
    }
    if (!calme) requestAnimationFrame(tic);
    else { beats.forEach(function (b) { b.classList.add('on'); }); }
  });
})();
